


















































































import {
  TcTextInput,
  TcButton,
  TcPageAlert
} from '@telia/shared-ui-components'
import {
  computed,
  defineComponent, PropType,
  ref,
  watch
} from '@vue/composition-api'

import AnslSpinner from '@/components/LoadingSpinner.vue'

import {
  getValidationState,
  getValidationMessage
} from '@/utils/form.utils'

import RichTextContainer from '@/components/rich-text-container/RichTextContainer.vue'
import { Document } from '@contentful/rich-text-types'
import QrcodeVue from 'qrcode.vue'

import {
  getQrToken, getAutoStartToken
} from '@/store/modules/authentication-v6.store'

import { createMobileReturnUrl, isMobileOrTablet } from '@/utils/device.utils'

export default defineComponent({
  components: {
    RichTextContainer,
    TcPageAlert,
    TcButton,
    TcTextInput,
    AnslSpinner,
    QrcodeVue
  },
  emits: ['authenticate', 'cancel'],
  props: {
    bankIdDescription: {
      type: Object as PropType<Document>,
      required: true
    },
    bankIdHelp: {
      type: Object as PropType<Document>,
      required: true
    },
    authenticationError: {
      type: String,
      default: ''
    },
    authenticationWarning: {
      type: String,
      default: ''
    },
    isAuthenticationOngoing: {
      type: Boolean,
      default: false
    },
    isCancellationOngoing: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const store = context.root.$store

    const qrHash = ref('')
    const qrToken = computed(() => getQrToken(store))
    const autoStartToken = computed(() => getAutoStartToken(store))

    watch(qrToken, (newValue) => {
      qrHash.value = newValue
    })

    const onCancel = () => {
      if (!props.isCancellationOngoing) {
        context.emit('cancel')
      }
    }

    const onSubmit = () => {
      if (!props.isAuthenticationOngoing) {
        context.emit('authenticate')
      }
    }

    const startBankIDAuthentication = () => {
      const autoStartTokenValue = autoStartToken.value
      if (props.authenticationError) {
        context.emit('authenticate')
      } else if (isMobileOrTablet) {
        const returnUrl = createMobileReturnUrl()
        const url = `https://app.bankid.com/?autostarttoken=${autoStartTokenValue}&redirect=${returnUrl}`
        window.location.href = url
      } else {
        const url = `bankid:///?autostarttoken=${autoStartTokenValue}&redirect=null`
        window.location.href = url
      }
    }

    return {
      onSubmit,
      onCancel,
      getValidationState,
      getValidationMessage,
      qrHash,
      qrToken,
      autoStartToken,
      startBankIDAuthentication
    }
  }
})
